// Al navegar entre localidades con los botones anterior/siguiente del mapa
// (Modallocalida.js -> irALocalidad), cada localidad de la lista de precios
// trae su propio campo "espacio" (el id_espacio que se usa para pedir sus
// asientos). En localidades de tipo fila/mesa ese campo a veces queda sin
// vincular en el editor SVG (la zona se dibuja y colorea, pero el enlace al
// id_espacio de sillas no se guarda), lo que antes disparaba el error "No se
// encontro la configuracion completa de la localidad" aunque la localidad
// fuera perfectamente valida.
//
// Todas las localidades de un mismo evento pertenecen al mismo
// espacio/venue, asi que si a la localidad destino le falta ese dato se
// puede reusar el espacio de la localidad que ya esta abierta (que por
// definicion es valido, porque su mapa ya se cargo con exito) en vez de
// bloquear la navegacion con un falso positivo.
export function resolverEspacioLocalidad(nuevaLocalidad, espacioActual) {
    return nuevaLocalidad?.espacio || espacioActual || null
}
